import mapboxgl, { Marker } from "mapbox-gl";
import { addTradeArea, setActiveMarker } from "../../../redux/slices/mapSlice";
import { labelFontSize } from "../../../utils/helper";
import { palette } from "../../../themes/theme";

export class CustomMarkerClass {
  static AddMarkerToPolygon = ({
    id,
    coordinates,
    type, // e.g: "polygon-trade-area"
    mapRef,
    drawRef,
    dispatch,
    name,
    polygonCoordinates = [],
    radiusSetting,
    resetAllOnceChanged,
    // showPointer,
    lastClickButton,
    resetActiveId,
    markerRef,
  }) => {
    const marker = new mapboxgl.Marker()
      .setLngLat([coordinates.longitude, coordinates.latitude])
      .addTo(mapRef);

    if (type === "polygon-trade-area") {
      const feature = drawRef.get(id);
      feature.properties["trade-area"] = true;
      drawRef.add(feature);
    }

    // marker.getElement().addEventListener("click", () => {
    //   dispatch(setActiveMarker(id));
    // });
    marker.getElement().style.cursor = "pointer";

    marker
      .getElement()
      .querySelector("svg")
      .querySelector("path")
      .setAttribute("fill", palette.primary.main);

    markerRef.current.push({ id, name, marker, type: "pointer" });

    dispatch(
      addTradeArea({
        id,
        latlng: {
          lng: coordinates.longitude,
          lat: coordinates.latitude,
        },
        type: type ? type : "trade-area",
        name,
        polygonCoordinates,
        radiusSetting,
        selected: true,
        pointer: { color: palette.primary.main, size: 30 },
        polygon: null,
      })
    );

    marker.getElement().addEventListener("mouseleave", () => {
      // showPointer.current = false;
      lastClickButton.current = 0;
    });

    marker.getElement().addEventListener("contextmenu", (event) => {
      // if (disableUserActions?.()) {
      //   return;
      // }
      event.preventDefault();
      resetAllOnceChanged();
      resetActiveId();
      dispatch(setActiveMarker(id));
      // setPointerSelected((previousValue) => {
      //   return {
      //     openSetting: true,
      //     name: defaultLogo.name,
      //     color: defaultLogo.color,
      //     size: defaultLogo.size,
      //     pointerId: id,
      //   };
      // });
    });
  };

  static recoverMarkerFromSaveMap = ({
    map,
    markerElement,
    coordinates,
    id,
    markerRef,
  }) => {
    const resizableBox = document.createElement("div");
    // const resizableContent = (
    //   <i
    //     className={`${markerElement.name} cursor-pointer`}
    //     id={id}
    //     data-type={"pointer"}
    //     style={{
    //       color: markerElement.color,
    //       fontSize: markerElement.size + "px",
    //     }}
    //   />
    // );
    // const root = createRoot(resizableBox);
    // root.render(resizableContent);
    const marker = new Marker({
      draggable: false,
      element: resizableBox,
    })
      .setLngLat(coordinates)
      .addTo(map);
    const markerElementAlter = marker.getElement();
    if (
      markerElement &&
      markerElement.dataset &&
      markerElement.dataset.display &&
      markerElement.dataset.display === "none"
    ) {
      markerElementAlter.style.display = "none";
    }
    markerRef.current.push({ id: id, marker: marker, type: "pointer" });
  };

  static recoverLabelMarkerFromMapData = ({
    id,
    coordinates,
    labelElement,
    map,
    updateAutoSave,
    dispatch,
    markerRef,
  }) => {
    const divElement = document.createElement("div");
    divElement.className = "text-marker";
    divElement.appendChild(labelElement);
    // getLabelActionIcon(labelElement,divElement, dispatch);

    const labelMarker = new mapboxgl.Marker({
      draggable: false,
      element: divElement,
    })
      .setLngLat([coordinates.lng, coordinates.lat])
      .addTo(map);
    markerRef.current.push({ id: id, marker: labelMarker, type: "textarea" });
    // Function to update text size based on zoom level
    function updateTextSize() {
      const zoomLevel = map.getZoom();
      const type = labelElement.innerHTML.toLowerCase().includes("radius")
        ? "radius"
        : "drive-time";
      const pTag = labelMarker.getElement().querySelector("p");
      const val = labelElement.innerHTML.match(/\d+/);
      CustomMarkerClass.updateLabelTextSize({
        zoom: zoomLevel,
        val,
        type,
        pTag,
      });
    }

    // Listen for zoom events on the map to update text size
    map.on("zoom", updateTextSize);

    updateAutoSave();
  };

  static updateLabelTextSize = ({ zoom, val, type, pTag }) => {
    const fontSize = labelFontSize(zoom, val, type);
    pTag.style.setProperty("font-size", `${fontSize}`, "important");
    pTag.style.setProperty(
      "display",
      fontSize === "0px" ? `none` : "block",
      "important"
    );
  };

  static RecoverPointerFromSaveMap = ({
    coordinates,
    pointerTag,
    mapboxgl,
    map,
    resetAllOnceChanged,
    updateAutoSave,
    showPointer,
    lastClickButton,
    disableUserActions,
    markerRef,
    dispatch,
  }) => {
    // Create the outer div element
    const outerDiv = document.createElement("div");
    const inputMarkerId = pointerTag.id;

    outerDiv.appendChild(pointerTag);
    if (pointerTag.dataset.display === "none") {
      outerDiv.style.display = "none";
    }
    // Create a draggable marker
    const marker = new mapboxgl.Marker(outerDiv, {
      draggable: false,
    })
      .setLngLat([coordinates.lng, coordinates.lat])
      .addTo(map);

    marker.getElement().style.cursor = "pointer";

    markerRef.current.push({
      id: inputMarkerId,
      marker: marker,
      type: "pointer",
    });

    marker.getElement().addEventListener("mouseleave", () => {
      showPointer.current = false;
      lastClickButton.current = 0;
    });
    outerDiv.addEventListener("contextmenu", (event) => {
      if (disableUserActions?.()) {
        return;
      }
      event.preventDefault();
      resetAllOnceChanged();
      dispatch(setActiveMarker(inputMarkerId));
    });
    updateAutoSave();
  };
}
